import React, { useEffect, useState } from 'react'
import { collection, getDocs, limit, query } from 'firebase/firestore'
import { db } from '../../firebase'
import { getPublicStorageUrl } from '../../utils'

export function Testimonial() {
  const [testimonial, setTestimonial] = useState({
    photo: '',
    name: '',
    quote: '',
    job: '',
  })

  async function fetchTestimonial() {
    try {
      const q = query(collection(db, 'testimonials'), limit(1))
      const querySnapshot = await getDocs(q)
      if (querySnapshot.empty) return

      const firstDoc = querySnapshot.docs[0]
      const photoUrl = getPublicStorageUrl('testimonials', firstDoc.data().image)

      setTestimonial({
        photo: photoUrl,
        name: firstDoc.data().name,
        quote: firstDoc.data().quote,
        job: firstDoc.data().job,
      })
    } catch (error) {
      console.error('Error fetching:', error)
    }
  }

  useEffect(() => {
    fetchTestimonial()
  }, [])

  if (!testimonial.photo || !testimonial.name || !testimonial.quote) return null

  return (
    <div
      className="w-full max-w-md mx-auto h-auto bg-white rounded-xl p-6"
      style={{ boxShadow: '0px 0px 22.399999618530273px rgba(147.93, 159.11, 217.81, 0.05)' }}
    >
      <div className="flex flex-col gap-6">
        <div className="flex items-center gap-4">
          <img
            className="w-14 h-14 rounded-full object-cover flex-shrink-0"
            src={testimonial.photo}
            alt={testimonial.name}
          />
          <div className="flex flex-col min-w-0">
            <p className="text-[#3f424a] text-lg font-medium font-['DM_Sans'] leading-relaxed truncate">
              {testimonial.name}
            </p>
            {testimonial.job && (
              <p className="text-[#62708d] text-sm font-normal font-['DM_Sans'] leading-tight truncate">
                {testimonial.job}
              </p>
            )}
          </div>
        </div>
        <p className="text-[#62708d] text-base font-normal font-['DM_Sans'] leading-relaxed break-words">
          {testimonial.quote}
        </p>
      </div>
    </div>
  )
}
